<template>
  <div class="banner">
    <div id="swiper-container-home" class="swiper-container">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, index) in formatBannerList"
          :key="index"
          :class="'swiper-slide' + (index + 1)"
          @click="handleClick(item)"
        >
          <img class="banner-img" :src="item.bannerUrl" alt="" />
          <div class="banner-text">
            <p class="title" v-html="item.bannerT"></p>
          </div>
          <div class="btn" @click.stop="handleClick(item)">
            <span>了解详情<img src="@/assets/images/btn.png" alt="" /></span>
          </div>
        </div>
      </div>

      <!-- 如果需要分页器 -->
      <div
        id="swiper-pagination-home"
        class="swiper-pagination hidden-sm-and-down"
      ></div>

      <!-- 如果需要导航按钮 -->
      <div
        id="swiper-button-prev-home"
        class="swiper-button-prev hidden-sm-and-down"
      ></div>
      <div
        id="swiper-button-next-home"
        class="swiper-button-next hidden-sm-and-down"
      ></div>
    </div>
  </div>
</template>

<script>
  import Swiper from "swiper"
  import "swiper/css/swiper.min.css"
  import "element-ui/lib/theme-chalk/display.css"
  import { getBanner } from "../api/home"
  export default {
    data() {
      return {
        bannerList: []
      }
    },
    computed: {
      formatBannerList() {
        return this.bannerList.map((item) => ({
          ...item,
          bannerT: item.bannerTitle.replace(/\s+/g, " ").replace(/ /g, "<br>")
        }))
      }
    },
    mounted() {
      this.handleQuery()
    },
    created() {},
    methods: {
      handleQuery() {
        getBanner()
          .then((res) => {
            this.bannerList = res.data.data
            this.bannerList = this.bannerList.filter(
              (item) => item.bannerUrl && item.isDisplay !== "1"
            )
            this.bannerList = this.$tool.sortByIndex(this.bannerList)

            this.$nextTick(() => {
              this.initSwiper()
            })
          })
          .catch((err) => {})
      },
      initSwiper() {
        var mySwiper = new Swiper("#swiper-container-home", {
          loop: true,
          touchRatio: 1,
          autoplay: {
            delay: 3000,
            stopOnLastSlide: false,
            disableOnInteraction: false
          },
          effect: "fade",
          slidesPerView: 1,
          slideToClickedSlide: true,
          pagination: {
            el: "#swiper-pagination-home"
          },
          navigation: {
            nextEl: "#swiper-button-next-home",
            prevEl: "#swiper-button-prev-home"
          },
          on: {
            slideChangeTransitionStart: function () {
              const activeIndex = this.activeIndex
              // 当banner切换时 给每个 swiper-slide 里面的 banner-text 添加一个样式
              // document
              //   .querySelectorAll(".swiper-slide")
              //   .forEach((slide, index) => {
              //     const bannerText = slide.querySelector(".banner-text")

              //     // 如果当前滑块是活动的，则添加样式
              //     if (index === activeIndex) {
              //       bannerText.classList.add("active")
              //     } else {
              //       // 移除其他滑块的样式
              //       bannerText.classList.remove("active")
              //     }
              //   })
            }
          }
        })
      },
      handleClick(item) {
        console.log("🚀 ~ handleClick ~ item:", item)
        if (item.clickJump === "0") {
          const apiUrl =
            process.env.VUE_APP_BASE_API +
            `/web/portal/banner/get/one?id=${item.id}`
          this.$store.commit("SET_API_URL", apiUrl)
          const payload = {
            activeParentMenu: "",
            activeMenu: "招考信息"
          }
          this.$store.commit("SET_ACTIVE_MENU", payload)

          this.$router.push({
            path: "/commonShow"
          })
        }
        if (item.clickJump === "1") {
          window.open(item.jumpUrl)
        }
        if (item.clickJump === "2") {
          console.log("内部路由")
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .banner {
    /* min-width: 1560px; */
    /* width: 1700px; */
    width: 1440px;
    height: 638px;
    clear: both;
    /* margin:0 auto; */
    margin-top: 134px;
    margin-left: auto;
    margin-right: auto;
    cursor: pointer;
  }
  .swiper-container {
    width: 100%;
    height: 100%;
  }
  .swiper-container img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .swiper-button-next {
    background-image: url("../assets/images/rs-arrow_r.png");
    background-size: 100%;
    width: 77px;
    height: 49px;
    top: 45%;
  }
  .swiper-button-prev {
    background-image: url("../assets/images/rs-arrow_l.png");
    background-size: 100%;
    width: 77px;
    height: 49px;
    top: 45%;
  }

  .swiper-button-next::after,
  .swiper-button-prev::after {
    content: "";
  }
  .banner-text {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: #fff;
    font-size: 30px;
  }
  .banner-text .title {
    white-space: pre-wrap;
    line-height: 50px;
  }
  .banner-text.active {
    animation: fadeIn 1.5s ease-in-out forwards;
  }
  .btn {
    background: #fff;
    border-radius: 35px;
    padding: 15px 40px;
    color: #0562f9;
    font-size: 28px;
    position: absolute;
    bottom: 10%;
    left: 50%;
    transform: translate(-50%, 0%);
    z-index: 999;
    img {
      padding-left: 30px;
      width: 13px;
      height: 18px;
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translate(-50%, -50%) scale(0.5); /* 开始时缩小并居中 */
    }
    to {
      opacity: 1;
      transform: translate(-50%, -50%) scale(1.5); /* 结束时恢复正常大小并居中 */
    }
  }

  .swiper-slide {
    height: 638px;
  }

  @media (max-width: 1440px) {
    .banner {
      width: 100%;
      height: auto;
      margin-top: 80px;
    }
    .swiper-container {
      height: auto;
    }
    @keyframes fadeIn {
      from {
        opacity: 0;
        transform: translate(-50%, -50%) scale(0.5); /* 开始时缩小并居中 */
      }
      to {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1.2); /* 结束时恢复正常大小并居中 */
      }
    }
    .banner {
      width: 100%;
      /* margin-left:15px;
        margin-right:15px; */
      // height: 350px;
      margin-top: 80px;
    }
    .swiper-container {
      /* width: 1920px; */
      width: 100%;
      /* height: 685px; */
    }
    .banner-text {
      top: 40%;
      font-size: 24px !important;
    }
    .banner-text .title {
      white-space: pre-wrap;
      line-height: 36px;
    }
    .btn {
      border-radius: 30px;
      padding: 10px 20px;
      color: #0562f9;
      font-size: 22px;
      position: absolute;
      bottom: 10%;
      left: 50%;
      transform: translate(-50%, 0%);
      z-index: 999;
      img {
        padding-left: 15px;
        width: 12px;
        height: 15px;
      }
    }
  }
  @media (max-width: 768px) {
    .swiper-slide {
      height: 160px;
    }
    .banner {
      width: 100%;
      height: auto;
      margin-top: 80px;
    }
    .swiper-container {
      height: auto;
    }
    .banner-text {
      top: 40%;
      font-size: 12px !important;
    }
    .banner-text .title {
      white-space: pre-wrap;
      line-height: 20px;
    }
    .btn {
      border-radius: 15px;
      padding: 5px 10px;
      color: #0562f9;
      font-size: 14px;
      position: absolute;
      bottom: 10%;
      left: 50%;
      transform: translate(-50%, 0%);
      z-index: 999;
      img {
        padding-left: 10px;
        width: 6px;
        height: 9px;
      }
    }
  }
</style>
